"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelStatus = props => {
  const {
    className = '',
    color,
    size = 1,
    zIndex = true
  } = props;
  const colorClass = color ? `${color.charAt(0).toUpperCase()}${color.slice(1)}` : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `statusIcon ${zIndex ? 'zIndex1' : ''} dis-fl-col jc-c a-c shadow-2dp w-fix-${size * 8} h-fix-${size * 8} pos-r brdCircle ${className}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `inside ${zIndex ? 'zIndex2' : ''} w-perc-75 h-perc-75 brdCircle bg${colorClass}400`
  }));
};
var _default = exports.default = BrixelStatus;